
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantCharityDto } from './merchantCharity.dto';
import { PaymentDto } from './payment.dto';

export class PaymentDonationDto extends BaseDto {
 
    amount?: number;

    payment?: PaymentDto;

    merchant?: MerchantDto;

    merchantCharity?: MerchantCharityDto;
}
